<template lang="pug">
  div
    //- Header(:content="headerContent")
    div.wrap-top
      ModuleHiro
      ModuleAbout
    Footer
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-tmp {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import Header from '@/components/shared/Header'
import ModuleHiro from '@/components/module/ModuleHiro'
import ModuleAbout from '@/components/module/ModuleAbout'
import Footer from '@/components/shared/Footer'

export default {
  components: {
    Header,
    ModuleHiro,
    ModuleAbout,
    Footer
  },
  data () {
    return {
      headerContent: {
        title: 'Home',
        left: {
          icon: 'mdi-close',
          action: () => {}
        },
        right: {
          label: 'Save',
          color: '#1976d2',
          action: () => {}
        }
      }
    }
  },
  methods: {
    onLoggedIn () {
    
    }
  }
}
</script>
